import * as Yup from 'yup';
import { validationRules } from '../constants';

/**
 * Validation schemas for Book Worksheet forms
 */

// Validation schema for literary group form
export const litGroupValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Literary group name is required')
    .min(validationRules.minNameLength, `Name must be at least ${validationRules.minNameLength} characters`)
    .max(validationRules.maxNameLength, `Name must be at most ${validationRules.maxNameLength} characters`),
  description: Yup.string()
    .required('Description is required')
    .min(10, 'Description must be at least 10 characters')
    .max(validationRules.maxDescriptionLength, `Description must be at most ${validationRules.maxDescriptionLength} characters`),
  type: Yup.string()
    .required('Literary group type is required')
    .oneOf(['collection', 'cycle', 'series', 'standalone', 'anthology'], 'Invalid literary group type'),
  priority: Yup.string()
    .required('Priority is required')
    .oneOf(['low', 'medium', 'high', 'urgent'], 'Invalid priority'),
  status: Yup.string()
    .required('Status is required')
    .oneOf(['new', 'not-started', 'in-progress', 'review', 'completed'], 'Invalid status'),
});

// Validation schema for book form
export const bookValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Book title is required')
    .min(validationRules.minNameLength, `Title must be at least ${validationRules.minNameLength} characters`)
    .max(validationRules.maxNameLength, `Title must be at most ${validationRules.maxNameLength} characters`),
  description: Yup.string()
    .required('Description is required')
    .min(10, 'Description must be at least 10 characters')
    .max(validationRules.maxDescriptionLength, `Description must be at most ${validationRules.maxDescriptionLength} characters`),
  author: Yup.string()
    .required('Author is required')
    .min(validationRules.minNameLength, `Author must be at least ${validationRules.minNameLength} characters`)
    .max(validationRules.maxNameLength, `Author must be at most ${validationRules.maxNameLength} characters`),
  series: Yup.string()
    .nullable(),
  bookCover: Yup.string()
    .nullable(),
  priority: Yup.string()
    .required('Priority is required')
    .oneOf(['low', 'medium', 'high', 'urgent'], 'Invalid priority'),
  status: Yup.string()
    .required('Status is required')
    .oneOf(['new', 'not-started', 'in-progress', 'review', 'completed'], 'Invalid status'),
  deadline: Yup.date()
    .nullable()
});

// Validation schema for character form
export const characterValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Character name is required')
    .min(validationRules.minNameLength, `Name must be at least ${validationRules.minNameLength} characters`)
    .max(validationRules.maxNameLength, `Name must be at most ${validationRules.maxNameLength} characters`),
  description: Yup.string()
    .required('Description is required')
    .min(10, 'Description must be at least 10 characters')
    .max(validationRules.maxDescriptionLength, `Description must be at most ${validationRules.maxDescriptionLength} characters`),
  avatarUrl: Yup.string()
    .nullable(),
  priority: Yup.string()
    .required('Priority is required')
    .oneOf(['low', 'medium', 'high', 'urgent'], 'Invalid priority'),
  status: Yup.string()
    .required('Status is required')
    .oneOf(['new', 'not-started', 'in-progress', 'review', 'completed'], 'Invalid status'),
  gender: Yup.string()
    .nullable()
    .oneOf(['male', 'female', 'non-binary', 'other', null], 'Invalid gender'),
  age: Yup.string()
    .nullable()
    .oneOf(['child', 'teen', 'young-adult', 'adult', 'senior', 'dragon', 'computer', null], 'Invalid age range')
});

// Validation schema for variation form - UPDATED TO MATCH CURRENT STATUS CONFIG
export const variationValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Variation name is required')
    .min(validationRules.minNameLength, `Name must be at least ${validationRules.minNameLength} characters`)
    .max(validationRules.maxNameLength, `Name must be at most ${validationRules.maxNameLength} characters`),
  content: Yup.string()
    .required('Content text is required')
    .min(1, 'Content text is required'),
  priority: Yup.string()
    .required('Priority is required')
    .oneOf(['low', 'medium', 'high', 'urgent'], 'Invalid priority'),
  status: Yup.string()
    .required('Status is required')
    .oneOf(['new', 'not-started', 'in-progress', 'review', 'completed'], 'Invalid status'),
  version: Yup.number()
    .required('Version is required')
    .min(1, 'Version must be at least 1')
    .integer('Version must be a whole number'),
  s3Url: Yup.string()
    .nullable(),
  fileDuration: Yup.number()
    .nullable()
    .min(0, 'Duration must be positive'),
  deadline: Yup.date()
    .nullable()
});

// Export all validation schemas
export default {
  litGroupValidationSchema,
  bookValidationSchema,
  characterValidationSchema,
  variationValidationSchema
};
